"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = require("@emotion/react");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    0% { opacity: 0; }\n  50% { opacity: 1; }\n  60% { opacity: 1; }\n  100% { opacity: 0; }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var toggleDot = (0, _react.keyframes)(_templateObject());
var dots = process.env.NODE_ENV === "production" ? {
  name: "24c0lf",
  styles: "span:first-of-type{animation-delay:0.2s;}span:nth-of-type(2){animation-delay:0.4s;}span:last-of-type{animation-delay:0.6s;}"
} : {
  name: "3o5ehe-dots",
  styles: "span:first-of-type{animation-delay:0.2s;}span:nth-of-type(2){animation-delay:0.4s;}span:last-of-type{animation-delay:0.6s;};label:dots;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var dot = /*#__PURE__*/(0, _react.css)("opacity:0;animation:", toggleDot, " 1s ease-in-out infinite;" + (process.env.NODE_ENV === "production" ? "" : ";label:dot;"));
var styles = {
  dots: dots,
  dot: dot
};
exports.styles = styles;
//# sourceMappingURL=AnimatedEllipsis.styles..js.map